module.exports = __webpack_public_path__ + "fb431a6f51806e4e4674bf0396c2433c.svg";